import React, { useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { createPopupInquiry } from "../api/api";

const HomePopupForm = ({ isOpen, onClose }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    contactNo: "",
    email: "",
    age: "",
    purpose: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const showToast = (message, isSuccess = true) => {
    const toast = document.createElement("div");
    toast.className = `fixed top-5 right-5 z-[9999] px-6 py-3 rounded-lg shadow-lg text-white font-lato transition-all duration-300 ${
      isSuccess ? "bg-green-500" : "bg-red-500"
    }`;
    toast.textContent = message;
    document.body.appendChild(toast);

    setTimeout(() => {
      toast.style.opacity = "0";
      setTimeout(() => {
        document.body.removeChild(toast);
      }, 300);
    }, 3000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const requestBody = {
      name: formData.fullName,
      phone: formData.contactNo,
      email: formData.email,
      age: formData.age,
      notes: formData.purpose,
    };

    try {
      const response = await createPopupInquiry(requestBody);
      console.log("API Response:", response);
      
      if (response.status === true || response.success === true) {
        showToast("Form Submitted Successfully!", true);
        
        setFormData({
          fullName: "",
          contactNo: "",
          email: "",
          age: "",
          purpose: "",
        });
        
        setTimeout(() => {
          onClose();
        }, 1500);
      } else {
        showToast(response.message || "Something went wrong. Please try again.", false);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      showToast(error.response?.data?.message || "Failed to submit. Please try again.", false);
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center px-4">
      <div className="bg-white w-full max-w-lg rounded-lg shadow-lg relative p-6 animate-fadeIn">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-black"
        >
          <RxCross2 size={24} />
        </button>

        <h2 className="text-xl font-bold mb-1 text-center font-merriweather">
          Book a Meeting
        </h2>

        <p className="text-gray-500 text-center mb-6 font-lato">
          Fill the form and our team will contact you shortly.
        </p>
        <form onSubmit={handleSubmit} className="space-y-4 font-lato">
          <input
            type="text"
            name="fullName"
            placeholder="Full Name"
            value={formData.fullName}
            onChange={handleChange}
            required
            className="w-full border p-3 rounded-md outline-none focus:border-blue-500"
          />
          <input
            type="tel"
            name="contactNo"
            placeholder="Contact Number"
            value={formData.contactNo}
            onChange={handleChange}
            maxLength="10"
            required
            className="w-full border p-3 rounded-md outline-none focus:border-blue-500"
          />
          <input
            type="email"
            name="email"
            placeholder="Email Address"
            value={formData.email}
            onChange={handleChange}
            required
            className="w-full border p-3 rounded-md outline-none focus:border-blue-500"
          />
          <input
            type="number"
            name="age"
            placeholder="Age"
            value={formData.age}
            onChange={handleChange}
            required
            className="w-full border p-3 rounded-md outline-none focus:border-blue-500"
          />
          <textarea
            name="purpose"
            placeholder="Purpose of Meeting"
            value={formData.purpose}
            onChange={handleChange}
            rows="3"
            required
            className="w-full border p-3 rounded-md outline-none focus:border-blue-500"
          ></textarea>
          <button
            type="submit"
            disabled={isLoading}
            className="w-full bg-[#bf9b30] text-white py-3 rounded-md hover:bg-[#9c7c22] transition disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoading ? "Submitting..." : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default HomePopupForm;